import React from "react";
import { Button, Card, CardBody, Container, Spinner } from "reactstrap";
import porcherMark from "../../assets/images/porcher-logo.png";
import porcherWordmark from "../../assets/images/porcher-wordmark.png";

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    padding: "48px 0",
    backgroundColor: "#f8f9fa",
  },
  content: { width: "100%", maxWidth: 480, margin: "0 auto", textAlign: "center" },
  brand: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 24,
  },
  accent: {
    height: 4,
    background: "linear-gradient(90deg, #556ee6 0%, #6f42c1 100%)",
  },
  code: {
    display: "inline-block",
    marginBottom: 16,
    padding: "4px 10px",
    borderRadius: 4,
    backgroundColor: "#eff2ff",
    color: "#556ee6",
    fontSize: "0.75rem",
    fontWeight: 600,
  },
  iconWrap: {
    width: 52,
    height: 52,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
    borderRadius: "50%",
    backgroundColor: "#556ee618",
  },
  icon: { color: "#556ee6", fontSize: "1.75rem", lineHeight: 1 },
  title: { margin: "0 0 8px", color: "#343a40", fontSize: "1.25rem", fontWeight: 600 },
  message: { margin: "0 auto 24px", maxWidth: 380, color: "#74788d", fontSize: "0.875rem", lineHeight: 1.6 },
  footer: { marginTop: 24, color: "#74788d", fontSize: "0.75rem" },
};

const SystemStatusPage = ({ code, icon, title, message, actionLabel, onAction, busy = false }) => (
  <main style={styles.page}>
    <Container>
      <section style={styles.content}>
        <a href="/" style={styles.brand} aria-label="Porcher home">
          <img src={porcherMark} alt="" height="36" />
          <img src={porcherWordmark} alt="Porcher" height="20" />
        </a>
        <Card className="border-0 shadow-sm overflow-hidden">
          <div style={styles.accent} />
          <CardBody className="p-4 p-sm-5">
            <span style={styles.code}>{code}</span>
            <div>
              <span style={styles.iconWrap}>
                <i className={`bx ${icon}`} style={styles.icon} aria-hidden="true" />
              </span>
            </div>
            <h1 style={styles.title}>{title}</h1>
            <p style={styles.message}>{message}</p>
            {actionLabel && (
              <Button color="primary" onClick={onAction} disabled={busy}>
                {busy ? <Spinner size="sm" /> : actionLabel}
              </Button>
            )}
          </CardBody>
        </Card>
        <p style={styles.footer}>© {new Date().getFullYear()} Porcher</p>
      </section>
    </Container>
  </main>
);

export const NotFoundPage = () => (
  <SystemStatusPage
    code="404"
    icon="bx-map-alt"
    title="Page not found"
    message="The page may have moved, or the address may be incorrect."
    actionLabel="Return home"
    onAction={() => window.location.assign("/")}
  />
);

export const ErrorPage = ({ onRetry }) => (
  <SystemStatusPage
    code="Something went wrong"
    icon="bx-error-circle"
    title="We hit an error"
    message="The page could not be loaded. Try again, or return to the home page."
    actionLabel="Try again"
    onAction={onRetry}
  />
);

export const MaintenancePage = ({ message, onEndMaintenance, busy }) => (
  <SystemStatusPage
    code="Scheduled maintenance"
    icon="bx-wrench"
    title="We’ll be right back"
    message={message || "Porcher is temporarily unavailable while we make improvements. Please check back soon."}
    actionLabel={onEndMaintenance ? "End maintenance" : undefined}
    onAction={onEndMaintenance}
    busy={busy}
  />
);

export default SystemStatusPage;